var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('input',{attrs:{"type":"number"},domProps:{"value":_vm.decimalValue},on:{"input":function($event){_vm.updateValue($event.target.value)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/common/currency-input.vue?vue&type=template&id=5e2398b6
// module id = +4Na
// module chunks = 0